import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_echec_game = _resolveComponent("echec-game")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_echec_game, { game: _ctx.game }, null, 8, ["game"])
  ]))
}